<template>
  <div style="width: 100%">
    <v-row
      style="width: 100%"
      :class="couponApplied && couponDetails ? 'px-6' : 'py-4 px-6'"
      no-gutters
      align="center"
    >
      <span class="checkout-h2">
        {{ $t("cart.tickets") }}
      </span>
      <v-spacer></v-spacer>
      <span
        class="secondary--text link mt-3 mr-3"
        v-if="showBackProducts"
        style="width: 28px; height: 28px"
        @click="backToSelect"
        ><v-img
          flat
          eager
          src="https://blueticket-cdn.s3.amazonaws.com/assets/icons/setores.svg"
        ></v-img
      ></span>

      <span
        class="secondary--text link mt-1 mr-2"
        v-if="showBackProducts && !$route.query.sectorMode"
        @click="backToSelect"
        >{{ $t("cart.sectors") }}</span
      >

      <v-divider
        :class="
          showCoupon || couponApplied
            ? 'ma-4'
            : $vuetify.breakpoint.mdAndUp
            ? 'mx-4'
            : 'mx-1'
        "
        vertical
        v-if="showBackProducts"
      ></v-divider>
      <span
        v-if="!showCoupon"
        class="secondary--text checkout-h5"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'mt-1 ml-2'"
        style="cursor: pointer"
        @click="showCoupon = !showCoupon"
        >{{ $t("cart.applyCoupon") }}</span
      >
      <v-col
        v-if="(showCoupon || couponApplied) && $vuetify.breakpoint.mdAndUp"
        cols="4"
      >
        <Coupon
          :sector="true"
          :couponApplied="couponApplied"
          :sectors="sectors"
          @clear="clear"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="(showCoupon || couponApplied) && !$vuetify.breakpoint.mdAndUp"
      no-gutters
      justify="center"
      class="pb-4"
    >
      <Coupon
        :sector="true"
        :couponApplied="couponApplied"
        :sectors="sectors"
        @clear="clear"
      />
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Coupon from "../Coupon.vue";
export default {
  data() {
    return {
      showCoupon: false,
    };
  },
  mounted() {
    if (this.couponDetails && this.couponDetails.isCupomValid)
      this.showCoupon = true;
  },
  computed: {
    ...mapGetters([
      "sectors",
      "noSectorList",
      "couponApplied",
      "couponDetails",
      "eventId",
    ]),
    showBackProducts() {
      return (
        this.sectors?.length > 1 ||
        (this.noSectorList?.length >= 1 && this.sectors?.length === 1)
      );
    },
  },
  methods: {
    backToSelect() {
      localStorage.removeItem(`show-map-${this.eventId}`);
      this.$store.commit("SET_SHOW_SEAT_MAP", false);
    },
    clear() {
      this.showCoupon = false;
    },
  },
  components: { Coupon },
};
</script>

<style scoped>
.link {
  cursor: pointer;
}
</style>
